import { reactive } from "vue";

export type Reason = "kick" | "leave" | "complete" | "network" | "expired" | "tarifftime" | "first-connect" | "new-auth" | "rejected"

export function goFinish(reason: Reason) {
  if (!finishState.finished) {
    finishState.finished = true;
    finishState.reason = reason;
  }
}

export const finishState = reactive<{
  finished: boolean;
  reason: Reason;
  fixReload: boolean
}>({
  finished: false,
  reason: "complete",
  fixReload: false
});
